import { __decorate } from "tslib";
import isObjectLike from "lodash-es/isObjectLike";
import { BaseState } from "./BaseState";
import { State } from 'vue-class-state';
import debounce from "lodash-es/debounce";
import { message } from 'ant-design-vue';
import { Action } from "./utils/Action";
import cloneDeep from "lodash-es/cloneDeep";
import getActionResultDesc, { resSchema } from "./param/getResultDesc";
import { isObject } from "lodash-es";
import { StateDefine } from "./utils/StateDefine";
import { defineArgs } from "./param/defineArgs";
import { getFormDataSchema } from "../stateCommon/form";
const formActions = {
  create: 'create',
  update: 'update',
  get: 'get',
  delete: 'delete',
  copy: 'copy'
};
const watcherSchema = {
  title: '表单监听事件',
  type: 'object',
  fields: [{
    id: 'id',
    title: 'id改变时时自动刷新数据',
    default: true
  }]
};
export class FormState extends BaseState {
  constructor(collection, options) {
    super(collection, options);
    this.stateModel = 'form';
    this.ucTag = '表单';
    this.props = ['id'];
    this.formData = {};
    this.id = '';
    this.oldData = {};
    this.initState();
  }
  async init() {
    try {
      if (this.id && this.getActionSupported('get')) {
        await this.dispatch('get');
      }
    } catch (error) {
      throw error;
    }
  }
  async createAction(isShowMessage = true, params) {
    const hasParams = isObject(params);
    const createParams = hasParams ? params : {
      body: this.formData
    };
    const res = await this.collection.create(createParams, {
      raw: hasParams
    });
    return this.checkSucc(res.body, {
      cgiName: 'create',
      success: () => {
        if (isShowMessage) {
          message.success('新建成功');
        }
        if (res.body.data) {
          this.oldData = cloneDeep(res.body.data);
          this.formData = res.body.data;
          const key = this.collection.getEntityPrimaryKey();
          if (typeof key === 'string') {
            this.id = res.body.data[key];
          }
        } else {
          console.warn('新建接口没有返回新建后的数据');
        }
      },
      showError: isShowMessage
    });
  }
  async updateAction(isShowMessage = true, params) {
    const hasParams = isObject(params);
    const res = await this.collection.update(hasParams ? params : {
      query: {
        id: this.id
      },
      body: this.formData
    }, {
      oldData: this.oldData,
      raw: hasParams
    });
    return this.checkSucc(res.body, {
      cgiName: 'update',
      success: () => {
        if (isShowMessage) {
          message.success('更新成功');
        }
        if (isObjectLike(res.body.data)) {
          this.oldData = cloneDeep(res.body.data);
          // 如果有返回数据就进行回写
          this.formData = res.body.data;
        } else {
          console.warn('接口没有返回更新后的数据');
        }
      },
      showError: isShowMessage
    });
  }
  async getAction(isShowMessage = true, params) {
    const hasParams = isObject(params);
    const {
      id
    } = this;
    const res = await this.collection.get(hasParams ? params : {
      query: {
        id
      },
      body: {
        id
      }
    }, {
      raw: hasParams
    });
    return this.checkSucc(res.body, {
      cgiName: 'get',
      success: () => {
        if (isObjectLike(res.body.data)) {
          this.oldData = cloneDeep(res.body.data);
          this.formData = res.body.data;
        } else {
          throw new Error(`[${this.collection.collectionData.collectionId}]数据源/[get]接口 id=${id} 返回的数据：${res.body.data}`);
        }
      },
      showError: isShowMessage
    });
  }
  async deleteAction(isShowMessage = true, params) {
    const hasParams = isObject(params);
    const res = await this.collection.delete(hasParams ? params : {
      query: {
        id: this.id
      },
      body: {
        id: this.id
      }
    }, {
      oldData: this.oldData,
      raw: hasParams
    });
    return this.checkSucc(res.body, {
      cgiName: 'delete',
      success: () => {
        // wuji的格式
        if (typeof res.body.data === 'boolean') {
          if (!res.body.data) {
            if (isShowMessage) {
              message.error('删除失败');
            }
            return;
          }
        }
        if (isShowMessage) {
          message.success('删除成功');
        }
      },
      showError: isShowMessage
    });
  }
  async copyAction(deleteId = true) {
    const clone = await this.collection.copyEntity(this.formData);
    if (deleteId) {
      const key = this.collection.getEntityPrimaryKey();
      if (key) {
        delete clone[key];
      }
    }
    return {
      success: true,
      data: clone
    };
  }
  registerWatcher() {
    const {
      stateWatcher
    } = this;
    const updateForm = debounce(() => this.dispatch('get'), 50);
    const events = [{
      id: 'id',
      trigger: () => this.id,
      callback: updateForm
    }];
    events.forEach(e => stateWatcher.register(e));
  }
}
FormState.watcherSchema = watcherSchema;
FormState.stateModel = 'form';
__decorate([StateDefine(getFormDataSchema), State], FormState.prototype, "formData", void 0);
__decorate([StateDefine({
  id: 'id',
  type: 'string',
  title: '表单主键值,供查询、更新接口使用'
}), State], FormState.prototype, "id", void 0);
__decorate([Action(formActions.create, {
  cgiDeps: ['create'],
  schema: {
    id: formActions.create,
    title: '创建',
    actionReturnValue: resSchema
  },
  defineArgs: defineArgs('create')
})], FormState.prototype, "createAction", null);
__decorate([Action(formActions.update, {
  cgiDeps: ['update'],
  schema: {
    id: formActions.update,
    title: '更新',
    actionReturnValue: resSchema
  },
  defineArgs: defineArgs('update')
})], FormState.prototype, "updateAction", null);
__decorate([Action(formActions.get, {
  cgiDeps: ['get'],
  schema: {
    id: formActions.get,
    title: '获取',
    actionReturnValue: resSchema
  },
  defineArgs: defineArgs('get')
})], FormState.prototype, "getAction", null);
__decorate([Action(formActions.delete, {
  cgiDeps: ['delete'],
  schema: {
    id: formActions.delete,
    title: '删除',
    actionReturnValue: resSchema
  },
  defineArgs: defineArgs('delete')
})], FormState.prototype, "deleteAction", null);
__decorate([Action(formActions.copy, {
  cgiDeps: [],
  schema: {
    id: formActions.copy,
    title: '复制表单数据',
    actionArguments: [{
      id: 'deleteId',
      title: '删除数据中的主键id,默认为true',
      type: 'boolean',
      required: false
    }],
    actionReturnValue: getActionResultDesc('复制的表单数据')
  }
})], FormState.prototype, "copyAction", null);
//# sourceMappingURL=FormState.js.map
